"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const cmd_1 = require("./cmd");
const parser_1 = require("./parser");
const errors_1 = require("./errors");
const utils_1 = require("./utils");
const semantic_json_1 = require("@hediet/semantic-json");
const schema_1 = require("./schema");
class Cli {
    constructor() {
        this._cmds = [];
        this._globalNamedArgs = {};
    }
    get TCmdData() {
        throw new Error("Do not access this field on runtime");
    }
    get TGlobalNamedArgs() {
        throw new Error("Do not access this field on runtime");
    }
    get mainCmd() {
        return this.findCmd(undefined);
    }
    findCmd(name) {
        return this._cmds.find(c => c.name === name);
    }
    get cmds() {
        return this._cmds;
    }
    get globalNamedArgs() {
        return this._globalNamedArgs;
    }
    addGlobalNamedArgs(args) {
        Object.assign(this._globalNamedArgs, utils_1.mapObject(args, (val, key) => new cmd_1.NamedCmdArg(key, val.type, val.description, val.shortName, val.excludeFromSchema)));
        return this;
    }
    addCmd(options) {
        const cmd = new cmd_1.Cmd(options.name, options.description, options.positionalArgs || [], Object.assign({}, options.namedArgs
            ? utils_1.mapObject(options.namedArgs, (val, key) => new cmd_1.NamedCmdArg(key, val.type, val.description, val.shortName, val.excludeFromSchema))
            : {}, this._globalNamedArgs), options.getData);
        if (this._cmds.find(c => c.name === cmd.name)) {
            throw new Error(`Command with name "${cmd.name}" has already been added.`);
        }
        this._cmds.push(cmd);
        return this;
    }
    parse(argv) {
        const parser = new parser_1.CmdParser();
        const errors = new errors_1.ErrorsImpl();
        const parsedCmd = parser.parseArgs(argv);
        errors.addFrom(parsedCmd.errors);
        const { updatedParsedCmd, selectedCmdName: selectedSubCmd, selectedCmd: cmd, } = this.selectCmd(parsedCmd);
        if (!cmd) {
            errors.addError(selectedSubCmd
                ? {
                    kind: "CommandNotFound",
                    command: selectedSubCmd,
                    message: `There is no command with name "${selectedSubCmd}".`,
                }
                : {
                    kind: "NoCommandSpecified",
                    message: `No command specified.`,
                });
            // We try to parse global named args to get at least anything.
            // This is important for the help command.
            const cmd = new cmd_1.Cmd(undefined, undefined, [], this.globalNamedArgs, undefined);
            const { parsedArgs } = cmd.parseArgs(parsedCmd);
            return {
                errors,
                parsedArgs: parsedArgs,
                dataFactory: undefined,
                selectedCmd: undefined,
            };
        }
        const result = cmd.parseArgs(updatedParsedCmd);
        if ("errors" in result) {
            errors.addFrom(result.errors);
        }
        return {
            errors,
            dataFactory: result.dataFactory,
            parsedArgs: result.parsedArgs,
            selectedCmd: cmd,
        };
    }
    selectCmd(
    // e.g. "prin foo"
    parsedCmd) {
        const subCmd = parsedCmd.prefixValue !== undefined &&
            this.findCmd(parsedCmd.prefixValue);
        if (subCmd) {
            return {
                updatedParsedCmd: new parser_1.ParsedCmd(parsedCmd.parts.slice(1), parsedCmd.errors),
                selectedCmdName: parsedCmd.prefixValue,
                selectedCmd: subCmd,
            };
        }
        else if (this.mainCmd) {
            // The prefix value could still refer to a miss-spelled command.
            return {
                updatedParsedCmd: parsedCmd,
                selectedCmdName: undefined,
                selectedCmd: this.mainCmd,
            };
        }
        else {
            // No main cmd and either no prefix value,
            // or it does not refer to an existing command.
            return {
                updatedParsedCmd: parsedCmd,
                selectedCmd: undefined,
                selectedCmdName: parsedCmd.prefixValue,
            };
        }
    }
    getSerializer() {
        const serializer = semantic_json_1.sUnion(...this.cmds.map(c => c.getSerializer())).defineAs(schema_1.cliNs("cmd"));
        return serializer;
    }
}
exports.Cli = Cli;
//# sourceMappingURL=cli.js.map